/**
 * Cennik montażu instalacji PV — stawki za kWp wg wielkości instalacji.
 *
 * ═══ TO JEST PLIK DO RĘCZNEJ EDYCJI ═══
 * Zmiana stawek to zmiana liczb w `PROGI_MONTAZU` poniżej i nic więcej. Nie ma tu
 * logiki poza wyborem progu, więc nie da się przy okazji zepsuć czegoś innego.
 *
 * Progi są DOMKNIĘTE OD DOŁU, otwarte od góry: `od: 8` łapie 8,00 kWp, a instalacja
 * 7,99 kWp wpada do progu niższego. Ostatni próg nie ma górnej granicy.
 *
 * Stawki obejmują robociznę RAZEM z materiałami pomocniczymi: okablowaniem AC i DC,
 * zabezpieczeniami AC/DC i drobnym osprzętem (potwierdzone przez właściciela 2026-09-27;
 * wcześniej ten komentarz błędnie mówił o samej robociźnie). Konstrukcja jest liczona osobno
 * (patrz `lib/konstrukcja`) i te dwie pozycje nie mogą się nakładać — w podsumowaniu
 * zestawu stoją jako dwie różne linie właśnie po to, żeby było widać, co jest czym.
 *
 * Stawki są POLSKIE, w złotych. Inne kraje nie mają jeszcze własnego cennika, więc
 * dostają polskie stawki przeliczone kursem na swoją walutę (`zZlotych` w kraj.js,
 * decyzja właściciela 2026-10-08). Wynik funkcji jest zawsze w walucie kraju.
 */

import { zZlotych } from '../kraj'

export const PROGI_MONTAZU = [
  { od: 0, do: 5, zlZaKwp: 1250 },
  { od: 5, do: 8, zlZaKwp: 1100 },
  { od: 8, do: 10, zlZaKwp: 1050 },
  { od: 10, do: 15, zlZaKwp: 950 },
  { od: 15, do: 20, zlZaKwp: 850 },
  { od: 20, do: null, zlZaKwp: 750 },
]

/** Stawka za kWp dla podanej mocy instalacji. */
export const stawkaMontazu = (kwp) => {
  const m = Number(kwp)
  if (!Number.isFinite(m) || m <= 0) return null
  const prog = PROGI_MONTAZU.find((p) => m >= p.od && (p.do == null || m < p.do))
  // Zaokrąglenie do pełnej jednostki: po przeliczeniu kursem wychodzą ułamki (1250 × 1,18).
  return Math.round(zZlotych(prog ? prog.zlZaKwp : PROGI_MONTAZU[PROGI_MONTAZU.length - 1].zlZaKwp))
}

/** Szacunkowy koszt montażu w złotych albo `null`, gdy nie znamy mocy instalacji. */
export const kosztMontazu = (kwp) => {
  const stawka = stawkaMontazu(kwp)
  if (stawka == null) return null
  return Math.round(stawka * Number(kwp))
}
